import React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  onStartVoteClick: () => void;
  isSendVoteDisabled: boolean;
  showStartVote: boolean;
}

export function StartVoteModal({
  open,
  onClose,
  onStartVoteClick,
  isSendVoteDisabled,
  showStartVote,
}: Props) {
  const headerText = showStartVote
    ? translate('Start a Vote?')
    : translate('More Responses!');
  const bodyText = showStartVote
    ? translate('This will end responses to the current question.')
    : translate(
        'You must have at least two student responses to start a vote.'
      );

  return (
    <DialogConfirmation
      id="start-vote"
      open={open}
      title={headerText}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        showStartVote && (
          <UIButton
            key="start-vote"
            isDisabled={isSendVoteDisabled}
            onClick={onStartVoteClick}
          >
            {translate('Start Vote')}
          </UIButton>
        ),
        showStartVote && (
          <UIButton key="cancel" onClick={onClose}>
            {translate('Cancel')}
          </UIButton>
        ),
        !showStartVote && (
          <UIButton key="ok" onClick={onClose}>
            {translate('Ok', true)}
          </UIButton>
        ),
      ]}
    >
      {bodyText}
    </DialogConfirmation>
  );
}
